export default function preparationItemUniqueReferenceNumberDirective(
  $q,
  amDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attrs, ngModel) {
    const auditId = attrs.auditId || -1;
    const preparationItemId = attrs.preparationItemId || -1;

    ngModel.$asyncValidators.amPreparationItemUniqueReferenceNumber = function (modelValue) {
      const defer = $q.defer();

      if (modelValue) {
        amDataService.checkPreparationItemReferenceNumberExists(auditId, preparationItemId, modelValue)
          .then((data) => {
            if (data && data.data.result === false) {
              defer.resolve();
            } else {
              defer.reject();
            }
          }).catch(defer.reject);
      } else {
        defer.resolve();
      }


      return defer.promise;
    };
  }
}

export const name = 'amPreparationItemUniqueReferenceNumber';

preparationItemUniqueReferenceNumberDirective.$inject = [
  '$q',
  'amDataService'
];
